var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down"},[(_vm.day)?[_c('span',[_vm._v(_vm._s(_vm.day))]),_c('em',{staticClass:"days"},[_vm._v("天")])]:_vm._e(),_c('span',[_vm._v(_vm._s(_vm.hour))]),_c('em',{staticClass:"hour"},[_vm._v(":")]),_c('span',[_vm._v(_vm._s(_vm.min))]),_c('em',{staticClass:"minute"},[_vm._v(":")]),_c('span',[_vm._v(_vm._s(_vm.sec))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }